export const DOCTOR_SCHEDULE_ROLES = [
  "super_admin", "admin", "sale", "accountant", "sleep_technician", "sleep_physician",
];

export const canManageDoctorSchedule = (roles = []) =>
  roles.some((role) => ["super_admin", "admin", "sale"].includes(role));
